import { WAIT, WAIT_SUCCESS, WAIT_FAIL, FETCH_RECORDS, FETCH_RECORDS_SUCCESS, FETCH_RECORDS_FAIL, EVENT, EVENT_SUCCESS, EVENT_FAIL } from "./types";
import { delRequest, getRequest, postRequest, putRequest } from "../../../core/network";
import endpoints from "../../../constants/endPoints.json";
import { notification } from "antd";
import download from "downloadjs";

export const generateTickets = (data, close) => (dispatch, useState) => {
    dispatch({ type: WAIT });
    const token = useState()?.auth?.token
    var end;

    switch (token.split(" ")[0]) {
        case "Admin": end = endpoints.admin.generateTickets; break;
        case "Super": end = endpoints.super.generateTickets; break;
        case "Partner": end = endpoints.partner.generateTickets; break;
        default: break;
    }

    if (data.download === "false") {
        postRequest(data, undefined, undefined, token, end)
            .then((response) => {
                notification.success({ message: response?.data?.message, style: { marginTop: "10vh" } })
                return dispatch({
                    type: WAIT_SUCCESS
                });
            })
            .catch((err) => {
                notification.error({ message: err?.response?.data?.message || "Something Went Wrong :(", style: { marginTop: "10vh" } })
                console.log(err);
                return dispatch({
                    type: WAIT_FAIL,
                });
            });
    } else {
        postRequest(data, { responseType: "arraybuffer" }, undefined, token, end)
            .then((response) => {
                download(response.data, response.headers["filename"], "application/zip")
                close && close()
                return dispatch({
                    type: WAIT_SUCCESS
                });
            })
            .catch((err) => {
                notification.error({ message: err?.response?.data?.message || "Something Went Wrong :(", style: { marginTop: "10vh" } })
                console.log(err);
                return dispatch({
                    type: WAIT_FAIL,
                });
            });
    }
};

export const resendTicket = (data, close) => (dispatch, useState) => {
    dispatch({ type: WAIT });
    const token = useState()?.auth?.token
    var end;

    getRequest(data, undefined, token, endpoints.super.resendTicket)
        .then((response) => {
            notification.success({ message: response?.data?.message, style: { marginTop: "10vh" } })
            return dispatch({
                type: WAIT_SUCCESS
            });
        })
        .catch((err) => {
            notification.error({ message: err?.response?.data?.message || "Something Went Wrong :(", style: { marginTop: "10vh" } })
            console.log(err);
            return dispatch({
                type: WAIT_FAIL,
            });
        });
};

export const deleteTicket = (data, close) => (dispatch, useState) => {
    dispatch({ type: WAIT });
    const token = useState()?.auth?.token

    delRequest(data, undefined, token, endpoints.super.deleteTicket)
        .then((response) => {
            notification.success({ message: response?.data?.message, style: { marginTop: "10vh" } })
            return dispatch({
                type: WAIT_SUCCESS
            });
        })
        .catch((err) => {
            notification.error({ message: err?.response?.data?.message || "Something Went Wrong :(", style: { marginTop: "10vh" } })
            console.log(err);
            return dispatch({
                type: WAIT_FAIL,
            });
        });
};

export const generateTicketsQRs = (data, close) => (dispatch, useState) => {
    dispatch({ type: WAIT });
    const token = useState()?.auth?.token
    var end;

    switch (token.split(" ")[0]) {
        case "Admin": end = endpoints.admin.generateTicketsQRs; break;
        case "Super": end = endpoints.super.generateTicketsQRs; break;
        default: break;
    }

    postRequest(data, { responseType: "arraybuffer" }, undefined, token, end)
        .then((response) => {
            download(response.data, response.headers["filename"], "application/pdf")
            close && close()
            return dispatch({
                type: WAIT_SUCCESS
            });
        })
        .catch((err) => {
            notification.error({ message: err?.response?.data?.message || "Something Went Wrong :(", style: { marginTop: "10vh" } })
            console.log(err);
            return dispatch({
                type: WAIT_FAIL,
            });
        });
};

export const generateInvitations = (data, close) => (dispatch, useState) => {
    dispatch({ type: WAIT });
    const token = useState()?.auth?.token
    var end;

    switch (token.split(" ")[0]) {
        case "Admin": end = endpoints.admin.generateInvitations; break;
        case "Super": end = endpoints.super.generateInvitations; break;
        default: break;
    }

    postRequest(data, undefined, undefined, token, end)
        .then((response) => {
            close && close()
            return dispatch({
                type: WAIT_SUCCESS
            });
        })
        .catch((err) => {
            notification.error({ message: err?.response?.data?.message || "Something Went Wrong :(", style: { marginTop: "10vh" } })
            console.log(err);
            return dispatch({
                type: WAIT_FAIL,
            });
        });
};

export const sendEventReminder = (data) => (dispatch, useState) => {
    dispatch({ type: WAIT });
    const token = useState()?.auth?.token
    var end;

    switch (token.split(" ")[0]) {
        case "Admin": end = endpoints.admin.sendEventReminder; break;
        case "Super": end = endpoints.super.sendEventReminder; break;
        default: break;
    }

    postRequest(data, undefined, undefined, token, end)
        .then((response) => {
            notification.success({ message: response?.data?.message || "Reminders sent successfully", style: { marginTop: "10vh" } })
            return dispatch({
                type: WAIT_SUCCESS
            });
        })
        .catch((err) => {
            notification.error({ message: err?.response?.data?.message || "Failed to send reminders", style: { marginTop: "10vh" } })
            console.log(err);
            return dispatch({
                type: WAIT_FAIL,
            });
        });
};

export const resendFailedInvitations = (data) => (dispatch, useState) => {
    dispatch({ type: WAIT });
    const token = useState()?.auth?.token
    var end;

    switch (token.split(" ")[0]) {
        case "Admin": end = endpoints.admin.resendInvitations; break;
        case "Super": end = endpoints.super.resendInvitations; break;
        default: break;
    }

    getRequest(data, undefined, token, end)
        .then((response) => {
            notification.success({ message: response?.data?.message || "Invitations sent successfully", style: { marginTop: "10vh" } })
            return dispatch({
                type: WAIT_SUCCESS
            });
        })
        .catch((err) => {
            notification.error({ message: err?.response?.data?.message || "Something Went Wrong :(", style: { marginTop: "10vh" } })
            console.log(err);
            return dispatch({
                type: WAIT_FAIL,
            });
        });
};

export const manuallyAcceptInvitation = (data) => (dispatch, useState) => {
    dispatch({ type: WAIT });
    const token = useState()?.auth?.token;
    let end;
    switch (token.split(" ")[0]) {
        case "Admin": end = endpoints.admin.manuallyAcceptInvitation; break;
        case "Super": end = endpoints.super.manuallyAcceptInvitation; break;
        default: break;
    }

    return postRequest(data, undefined, undefined, token, end)
        .then((response) => {
            notification.success({
                message: response?.data?.message || "Invitation processed successfully",
                style: { marginTop: "10vh" }
            });
            return dispatch({
                type: WAIT_SUCCESS
            });
        })
        .catch((err) => {
            notification.error({
                message: err?.response?.data?.message || "Something Went Wrong :(",
                style: { marginTop: "10vh" }
            });
            console.log(err);
            dispatch({
                type: WAIT_FAIL,
            });
            throw err;
        });
};

export const manuallyAcceptCampaignInvitation = (data) => (dispatch, useState) => {
    dispatch({ type: WAIT });
    const token = useState()?.auth?.token;
    let end;
    switch (token.split(" ")[0]) {
        case "Admin": end = endpoints.admin.manuallyAcceptCampaignInvitation; break;
        case "Super": end = endpoints.super.manuallyAcceptCampaignInvitation; break;
        default: break;
    }

    return postRequest(data, undefined, undefined, token, end)
        .then((response) => {
            notification.success({
                message: response?.data?.message || "Campaign invitation processed successfully",
                style: { marginTop: "10vh" }
            });
            return dispatch({
                type: WAIT_SUCCESS
            });
        })
        .catch((err) => {
            notification.error({
                message: err?.response?.data?.message || "Something Went Wrong :(",
                style: { marginTop: "10vh" }
            });
            console.log(err);
            dispatch({
                type: WAIT_FAIL,
            });
            throw err;
        });
};

export const generateRequestDetails = (data, close) => (dispatch, useState) => {
    dispatch({ type: WAIT });
    const token = useState()?.auth?.token
    var end;

    switch (token.split(" ")[0]) {
        case "Admin": end = endpoints.admin.generateRequestDetails; break;
        case "Super": end = endpoints.super.generateRequestDetails; break;
        case "Partner": end = endpoints.partner.generateRequestDetails; break;
        default: break;
    }

    getRequest({ ...data, responseType: "arraybuffer" }, undefined, token, end)
        .then((response) => {
            download(response.data, response.headers["filename"], "text/csv")
            close && close()
            return dispatch({
                type: WAIT_SUCCESS
            });
        })
        .catch((err) => {
            notification.error({ message: err?.response?.data?.message || "Something Went Wrong :(", style: { marginTop: "10vh" } })
            console.log(err);
            return dispatch({
                type: WAIT_FAIL,
            });
        });
};

export const getUshers = (data) => (dispatch, useState) => {
    dispatch({ type: FETCH_RECORDS });
    const token = useState()?.auth?.token
    var end;

    switch (token.split(" ")[0]) {
        case "Admin": end = endpoints.admin.viewUshers; break;
        case "Super": end = endpoints.super.viewUshers; break;
        case "Partner": end = endpoints.partner.viewUshers; break;
        default: break;
    }

    getRequest(data, undefined, token, end)
        .then((response) => {
            const { data } = response;
            return dispatch({
                type: FETCH_RECORDS_SUCCESS,
                payload: data
            });
        })
        .catch((err) => {
            notification.error({ message: err?.response?.data?.message, style: { marginTop: "10vh" } })
            console.log(err);
            return dispatch({
                type: FETCH_RECORDS_FAIL,
            });
        });
};

export const getPartners = (data) => (dispatch, useState) => {
    dispatch({ type: FETCH_RECORDS });
    const token = useState()?.auth?.token

    getRequest(data, undefined, token, endpoints.super.listPartners)
        .then((response) => {
            const { data } = response;
            return dispatch({
                type: FETCH_RECORDS_SUCCESS,
                payload: data
            });
        })
        .catch((err) => {
            notification.error({ message: err?.response?.data?.message, style: { marginTop: "10vh" } })
            console.log(err);
            return dispatch({
                type: FETCH_RECORDS_FAIL,
            });
        });
};

export const createUsher = (data, close) => (dispatch, useState) => {
    dispatch({ type: WAIT });
    const token = useState()?.auth?.token

    postRequest(data, undefined, undefined, token, endpoints.super.createUsher)
        .then((response) => {
            close && close()
            return dispatch({
                type: WAIT_SUCCESS
            });
        })
        .catch((err) => {
            notification.error({ message: err?.response?.data?.message, style: { marginTop: "10vh" } })
            console.log(err);
            return dispatch({
                type: WAIT_FAIL,
            });
        });
};

export const createPartner = (data, navigate) => (dispatch, useState) => {
    dispatch({ type: WAIT });
    const token = useState()?.auth?.token

    postRequest(data, undefined, undefined, token, endpoints.super.createPartner)
        .then((response) => {
            navigate && navigate(-1)
            return dispatch({
                type: WAIT_SUCCESS
            });
        })
        .catch((err) => {
            notification.error({ message: err?.response?.data?.message, style: { marginTop: "10vh" } })
            console.log(err);
            return dispatch({
                type: WAIT_FAIL,
            });
        });
};

export const editPartner = (data, navigate) => (dispatch, useState) => {
    dispatch({ type: WAIT });
    const token = useState()?.auth?.token

    putRequest(data, undefined, undefined, token, endpoints.super.editPartner)
        .then((response) => {
            const { data } = response
            notification.success({ message: "Partner Edited", style: { marginTop: "10vh" } })
            navigate && navigate(-1)
            return dispatch({
                type: WAIT_SUCCESS
            });
        })
        .catch((err) => {
            notification.error({ message: err?.response?.data?.message, style: { marginTop: "10vh" } })
            console.log(err);
            return dispatch({
                type: WAIT_FAIL,
            });
        });
};

export const deletePartner = (data) => (dispatch, useState) => {
    dispatch({ type: WAIT });
    const token = useState()?.auth?.token

    delRequest(data, undefined, token, endpoints.super.deletePartner)
        .then((response) => {
            const { data } = response
            return dispatch({
                type: WAIT_SUCCESS
            });
        })
        .catch((err) => {
            notification.error({ message: err?.response?.data?.message, style: { marginTop: "10vh" } })
            console.log(err);
            return dispatch({
                type: WAIT_FAIL,
            });
        });
};

export const addFeaturedEvent = (data) => (dispatch, useState) => {
    dispatch({ type: EVENT });
    const token = useState()?.auth?.token

    postRequest(data, undefined, undefined, token, endpoints.super.featuredEvent)
        .then((response) => {
            const { data } = response
            let events = useState()?.events?.results
            events.docs = events?.docs?.map((event) => {
                if (event._id === data._id) {
                    return data
                } else {
                    return { ...event }
                }
            })
            return dispatch({
                type: EVENT_SUCCESS,
                payload: { ...events }
            });
        })
        .catch((err) => {
            notification.error({ message: err?.response?.data?.message, style: { marginTop: "10vh" } })
            console.log(err);
            return dispatch({
                type: EVENT_FAIL,
            });
        });
};

export const removeFeaturedEvent = (data) => (dispatch, useState) => {
    dispatch({ type: EVENT });
    const token = useState()?.auth?.token

    delRequest(data, undefined, token, endpoints.super.featuredEvent)
        .then((response) => {
            const { data } = response
            let events = useState()?.events?.results
            events.docs = events?.docs?.map((event) => {
                if (event._id === data._id) {
                    return data
                } else {
                    return { ...event }
                }
            })
            return dispatch({
                type: EVENT_SUCCESS,
                payload: { ...events }
            });
        })
        .catch((err) => {
            notification.error({ message: err?.response?.data?.message, style: { marginTop: "10vh" } })
            console.log(err);
            return dispatch({
                type: EVENT_FAIL,
            });
        });
};

export const getTicketRequestsAdmin = (data) => (dispatch, useState) => {
    dispatch({ type: FETCH_RECORDS });
    const token = useState()?.auth?.token
    var end;

    switch (token.split(" ")[0]) {
        case "Admin": end = endpoints.admin.requests.root; break;
        case "Super": end = endpoints.super.requests.root; break;
        case "Partner": end = endpoints.partner.requests.root; break;
        default: break;
    }

    getRequest(data, undefined, token, end)
        .then((response) => {
            const { data } = response
            return dispatch({
                type: FETCH_RECORDS_SUCCESS,
                payload: data
            });
        })
        .catch((err) => {
            notification.error({ message: err?.response?.data?.message, style: { marginTop: "10vh" } })
            console.log(err);
            return dispatch({
                type: FETCH_RECORDS_FAIL,
            });
        });
};

export const getEventTickets = (data) => (dispatch, useState) => {
    dispatch({ type: FETCH_RECORDS });
    const token = useState()?.auth?.token
    var end;

    switch (token.split(" ")[0]) {
        case "Admin": end = endpoints.admin.eventTickets; break;
        case "Super": end = endpoints.super.eventTickets; break;
        case "Partner": end = endpoints.partner.eventTickets; break;
        default: break;
    }

    getRequest(data, undefined, token, end)
        .then((response) => {
            const { data } = response
            return dispatch({
                type: FETCH_RECORDS_SUCCESS,
                payload: data
            });
        })
        .catch((err) => {
            notification.error({ message: err?.response?.data?.message, style: { marginTop: "10vh" } })
            console.log(err);
            return dispatch({
                type: FETCH_RECORDS_FAIL,
            });
        });
};

export const deleteUshers = (data) => (dispatch, useState) => {
    dispatch({ type: WAIT });
    const token = useState()?.auth?.token

    delRequest(data, undefined, token, endpoints.super.deleteUsher)
        .then((response) => {
            const { data } = response
            return dispatch({
                type: WAIT_SUCCESS
            });
        })
        .catch((err) => {
            notification.error({ message: err?.response?.data?.message, style: { marginTop: "10vh" } })
            console.log(err);
            return dispatch({
                type: WAIT_FAIL,
            });
        });
};

const requestsInitialState = {
    status: "Unseen",
    search: "",
    page: 1,
    limit: 10
}

export const acceptTicketRequest = (data) => (dispatch, useState) => {
    dispatch({ type: WAIT });
    const token = useState()?.auth?.token
    var end;

    switch (token.split(" ")[0]) {
        case "Admin": end = endpoints.admin.requests.accept; break;
        case "Super": end = endpoints.super.requests.accept; break;
        case "Partner": end = endpoints.partner.requests.accept; break;
        default: break;
    }

    postRequest(data, undefined, undefined, token, end)
        .then((response) => {
            const { data } = response
            return dispatch({
                type: WAIT_SUCCESS
            });
        })
        .catch((err) => {
            notification.error({ message: err?.response?.data?.message, style: { marginTop: "10vh" } })
            console.log(err);
            return dispatch({
                type: WAIT_FAIL,
            });
        });
};

export const rejectTicketRequest = (data) => (dispatch, useState) => {
    dispatch({ type: WAIT });
    const token = useState()?.auth?.token
    var end;

    switch (token.split(" ")[0]) {
        case "Admin": end = endpoints.admin.requests.reject; break;
        case "Super": end = endpoints.super.requests.reject; break;
        case "Partner": end = endpoints.partner.requests.reject; break;
        default: break;
    }

    postRequest(data, undefined, undefined, token, end)
        .then((response) => {
            const { data } = response
            return dispatch({
                type: WAIT_SUCCESS
            });
        })
        .catch((err) => {
            notification.error({ message: err?.response?.data?.message, style: { marginTop: "10vh" } })
            console.log(err);
            return dispatch({
                type: WAIT_FAIL,
            });
        });
};

export const fulfillTicketRequest = (data) => (dispatch, useState) => {
    dispatch({ type: WAIT });
    const token = useState()?.auth?.token
    var end;

    switch (token.split(" ")[0]) {
        case "Admin": end = endpoints.admin.requests.fulfill; break;
        case "Super": end = endpoints.super.requests.fulfill; break;
        case "Partner": end = endpoints.partner.requests.fulfill; break;
        default: break;
    }

    postRequest(data, undefined, undefined, token, end)
        .then((response) => {
            const { data } = response
            return dispatch({
                type: WAIT_SUCCESS
            });
        })
        .catch((err) => {
            notification.error({ message: err?.response?.data?.message, style: { marginTop: "10vh" } })
            console.log(err);
            return dispatch({
                type: WAIT_FAIL,
            });
        });
};

export const getOrders = (data) => (dispatch, useState) => {
    dispatch({ type: FETCH_RECORDS });
    const token = useState()?.auth?.token
    var end;

    switch (token.split(" ")[0]) {
        case "Admin": end = endpoints.admin.orders; break;
        case "Super": end = endpoints.super.orders; break;
        case "Partner": end = endpoints.partner.orders; break;
        default: break;
    }

    getRequest(data, undefined, token, end)
        .then((response) => {
            const { data } = response
            return dispatch({
                type: FETCH_RECORDS_SUCCESS,
                payload: data
            });
        })
        .catch((err) => {
            notification.error({ message: err?.response?.data?.message, style: { marginTop: "10vh" } })
            console.log(err);
            return dispatch({
                type: FETCH_RECORDS_FAIL,
            });
        });
};

export const fulfillTransfer = (data) => (dispatch, useState) => {
    dispatch({ type: WAIT });
    const token = useState()?.auth?.token
    var end;

    switch (token.split(" ")[0]) {
        case "Admin": end = endpoints.admin.transfer; break;
        case "Super": end = endpoints.super.transfer; break;
        case "Partner": end = endpoints.partner.transfer; break;
        default: break;
    }

    postRequest(data, undefined, undefined, token, end)
        .then((response) => {
            const { data } = response
            return dispatch({
                type: WAIT_SUCCESS
            });
        })
        .catch((err) => {
            notification.error({ message: err?.response?.data?.message, style: { marginTop: "10vh" } })
            console.log(err);
            return dispatch({
                type: WAIT_FAIL,
            });
        });
};

export const createWhatsappTemplate = (data, navigate) => (dispatch, useState) => {
    dispatch({ type: WAIT });
    const token = useState()?.auth?.token
    var end;

    switch (token.split(" ")[0]) {
        case "Admin": end = endpoints.admin.whatsapp.createTemplate; break;
        case "Super": end = endpoints.super.whatsapp.createTemplate; break;
        default: break;
    }

    postRequest(data, undefined, undefined, token, end)
        .then((response) => {
            const { data } = response
            notification.success({ message: "Template Created Successfully", style: { marginTop: "10vh" } })
            navigate && navigate("/Admin/whatsappTemplates")
            return dispatch({
                type: WAIT_SUCCESS
            });
        })
        .catch((err) => {
            notification.error({ message: err?.response?.data?.message, style: { marginTop: "10vh" } })
            console.log(err);
            return dispatch({
                type: WAIT_FAIL,
            });
        });
};

export const fetchWhatsappTemplateForEdit = (id) => (dispatch, useState) => {
    const token = useState()?.auth?.token;
    let end;
    switch (token.split(" ")[0]) {
        case "Admin": end = `admins/whatsappTemplate/${id}/forEdit`; break;
        case "Super": end = `super/whatsappTemplate/${id}/forEdit`; break;
        default: return Promise.reject(new Error("Invalid role"));
    }
    return getRequest(undefined, undefined, token, end).then((r) => r.data);
};

export const updateWhatsappTemplate = (id, data, navigate) => (dispatch, useState) => {
    dispatch({ type: WAIT });
    const token = useState()?.auth?.token;
    let end;
    switch (token.split(" ")[0]) {
        case "Admin": end = `admins/whatsappTemplate/${id}`; break;
        case "Super": end = `super/whatsappTemplate/${id}`; break;
        default: break;
    }
    return putRequest(data, undefined, undefined, token, end)
        .then(() => {
            notification.success({ message: "Template updated successfully", style: { marginTop: "10vh" } });
            navigate && navigate("/Admin/whatsappTemplates");
            return dispatch({ type: WAIT_SUCCESS });
        })
        .catch((err) => {
            notification.error({ message: err?.response?.data?.message || "Update failed", style: { marginTop: "10vh" } });
            console.log(err);
            return dispatch({ type: WAIT_FAIL });
        });
};

export const deleteWhatsappTemplate = (id, navigate, onDeleted) => (dispatch, useState) => {
    dispatch({ type: WAIT });
    const token = useState()?.auth?.token;
    let end;
    switch (token.split(" ")[0]) {
        case "Admin": end = `admins/whatsappTemplate/${id}`; break;
        case "Super": end = `super/whatsappTemplate/${id}`; break;
        default: break;
    }
    return delRequest(undefined, undefined, token, end)
        .then(() => {
            notification.success({ message: "Template deleted", style: { marginTop: "10vh" } });
            navigate && navigate("/Admin/whatsappTemplates");
            onDeleted && onDeleted();
            return dispatch({ type: WAIT_SUCCESS });
        })
        .catch((err) => {
            notification.error({ message: err?.response?.data?.message || "Delete failed", style: { marginTop: "10vh" } });
            console.log(err);
            return dispatch({ type: WAIT_FAIL });
        });
};

/** Uploads bucket URL to Meta resumable API; returns { assetHandle, publicUrl }. Uses super route (Admin + Super tokens). */
export const uploadWhatsappHeaderMeta = (data) => (dispatch, useState) => {
    const token = useState()?.auth?.token;
    const end = endpoints.super.whatsapp.uploadHeaderMeta;
    return postRequest(data, undefined, undefined, token, end)
        .then((response) => response.data)
        .catch((err) => {
            notification.error({
                message: err?.response?.data?.message || "Meta header upload failed",
                style: { marginTop: "10vh" },
            });
            throw err;
        });
};

export const getWhatsappTemplates = (data) => (dispatch, useState) => {
    dispatch({ type: FETCH_RECORDS });
    const token = useState()?.auth?.token
    var end;

    switch (token.split(" ")[0]) {
        case "Admin": end = endpoints.admin.whatsapp.viewAllTemplates; break;
        case "Super": end = endpoints.super.whatsapp.viewAllTemplates; break;
        default: break;
    }

    getRequest(data, undefined, token, end)
        .then((response) => {
            const { data } = response
            return dispatch({
                type: FETCH_RECORDS_SUCCESS,
                payload: data
            });
        })
        .catch((err) => {
            notification.error({ message: err?.response?.data?.message, style: { marginTop: "10vh" } })
            console.log(err);
            return dispatch({
                type: FETCH_RECORDS_FAIL,
            });
        });
};

export const createWhatsappCampaign = (data, navigate) => (dispatch, useState) => {
    dispatch({ type: WAIT });
    const token = useState()?.auth?.token
    var end;

    switch (token.split(" ")[0]) {
        case "Admin": end = endpoints.admin.whatsapp.createCampaign; break;
        case "Super": end = endpoints.super.whatsapp.createCampaign; break;
        default: break;
    }

    postRequest(data, undefined, undefined, token, end)
        .then((response) => {
            const { data } = response
            notification.success({ message: "Campaign Created Successfully", style: { marginTop: "10vh" } })
            navigate && navigate("/Admin/whatsappCampaigns")
            return dispatch({
                type: WAIT_SUCCESS
            });
        })
        .catch((err) => {
            notification.error({ message: err?.response?.data?.message, style: { marginTop: "10vh" } })
            console.log(err);
            return dispatch({
                type: WAIT_FAIL,
            });
        });
};

export const getWhatsappCampaigns = (data) => (dispatch, useState) => {
    dispatch({ type: FETCH_RECORDS });
    const token = useState()?.auth?.token
    var end;

    switch (token.split(" ")[0]) {
        case "Admin": end = endpoints.admin.whatsapp.viewAllCampaigns; break;
        case "Super": end = endpoints.super.whatsapp.viewAllCampaigns; break;
        default: break;
    }

    getRequest(data, undefined, token, end)
        .then((response) => {
            const { data } = response
            return dispatch({
                type: FETCH_RECORDS_SUCCESS,
                payload: data
            });
        })
        .catch((err) => {
            notification.error({ message: err?.response?.data?.message, style: { marginTop: "10vh" } })
            console.log(err);
            return dispatch({
                type: FETCH_RECORDS_FAIL,
            });
        });
};

export const generateWhatsappCampaignInvitations = (data, close) => (dispatch, useState) => {
    dispatch({ type: WAIT });
    const token = useState()?.auth?.token
    var end;

    switch (token.split(" ")[0]) {
        case "Admin": end = endpoints.admin.whatsapp.generateInvitations; break;
        case "Super": end = endpoints.super.whatsapp.generateInvitations; break;
        default: break;
    }

    postRequest(data, undefined, undefined, token, end)
        .then((response) => {
            close && close()
            return dispatch({
                type: WAIT_SUCCESS
            });
        })
        .catch((err) => {
            notification.error({ message: err?.response?.data?.message || "Something Went Wrong :(", style: { marginTop: "10vh" } })
            console.log(err);
            return dispatch({
                type: WAIT_FAIL,
            });
        });
};

export const getWhatsappCampaignInvitations = (data) => (dispatch, useState) => {
    dispatch({ type: FETCH_RECORDS });
    const token = useState()?.auth?.token
    var end;

    switch (token.split(" ")[0]) {
        case "Admin": end = endpoints.admin.whatsapp.viewCampaignInvitations; break;
        case "Super": end = endpoints.super.whatsapp.viewCampaignInvitations; break;
        default: break;
    }

    getRequest(data, undefined, token, end)
        .then((response) => {
            const { data } = response
            return dispatch({
                type: FETCH_RECORDS_SUCCESS,
                payload: data
            });
        })
        .catch((err) => {
            notification.error({ message: err?.response?.data?.message, style: { marginTop: "10vh" } })
            console.log(err);
            return dispatch({
                type: FETCH_RECORDS_FAIL,
            });
        });
};

export const getWhatsappConversations = (data) => (dispatch, useState) => {
    dispatch({ type: FETCH_RECORDS });
    const token = useState()?.auth?.token;
    let end;

    switch (token.split(" ")[0]) {
        case "Admin": end = endpoints.admin.whatsapp.viewConversations; break;
        case "Super": end = endpoints.super.whatsapp.viewConversations; break;
        default: break;
    }

    getRequest(data, undefined, token, end)
        .then((response) => {
            const { data } = response;
            return dispatch({
                type: FETCH_RECORDS_SUCCESS,
                payload: data
            });
        })
        .catch((err) => {
            notification.error({ message: err?.response?.data?.message || "Unable to load WhatsApp conversations", style: { marginTop: "10vh" } });
            console.log(err);
            return dispatch({
                type: FETCH_RECORDS_FAIL,
            });
        });
};

export const getWhatsappConversationMessages = ({ number, ...params }) => (dispatch, useState) => {
    dispatch({ type: FETCH_RECORDS });
    const token = useState()?.auth?.token;
    let end;

    switch (token.split(" ")[0]) {
        case "Admin": end = endpoints.admin.whatsapp.viewConversationMessages; break;
        case "Super": end = endpoints.super.whatsapp.viewConversationMessages; break;
        default: break;
    }

    getRequest(params, undefined, token, `${end}/${number}/messages`)
        .then((response) => {
            const { data } = response;
            return dispatch({
                type: FETCH_RECORDS_SUCCESS,
                payload: data
            });
        })
        .catch((err) => {
            notification.error({ message: err?.response?.data?.message || "Unable to load WhatsApp messages", style: { marginTop: "10vh" } });
            console.log(err);
            return dispatch({
                type: FETCH_RECORDS_FAIL,
            });
        });
};

export const sendWhatsappConversationMessage = (data) => (dispatch, useState) => {
    dispatch({ type: WAIT });
    const token = useState()?.auth?.token;
    let end;

    switch (token.split(" ")[0]) {
        case "Admin": end = endpoints.admin.whatsapp.sendConversationMessage; break;
        case "Super": end = endpoints.super.whatsapp.sendConversationMessage; break;
        default: break;
    }

    return postRequest(data, undefined, undefined, token, end)
        .then((response) => {
            notification.success({
                message: response?.data?.message || "Message sent successfully",
                style: { marginTop: "10vh" }
            });
            return dispatch({
                type: WAIT_SUCCESS
            });
        })
        .catch((err) => {
            notification.error({
                message: err?.response?.data?.message || "Unable to send message",
                style: { marginTop: "10vh" }
            });
            console.log(err);
            dispatch({
                type: WAIT_FAIL,
            });
            throw err;
        });
};

export const downloadCampaignInvitations = (data) => (dispatch, useState) => {
    dispatch({ type: WAIT });
    const token = useState()?.auth?.token
    var end;

    switch (token.split(" ")[0]) {
        case "Admin": end = endpoints.admin.whatsapp.exportCampaignInvitations; break;
        case "Super": end = endpoints.super.whatsapp.exportCampaignInvitations; break;
        default: break;
    }

    notification.info({ message: "Downloading Campaign Invitations...", style: { marginTop: "10vh" } })
    getRequest({ ...data, responseType: "arraybuffer" }, undefined, token, end)
        .then((response) => {
            download(response.data, response.headers["filename"], "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet")
            return dispatch({
                type: WAIT_SUCCESS
            });
        })
        .catch((err) => {
            notification.error({ message: err?.response?.data?.message })
            console.log(err);
            return dispatch({
                type: WAIT_FAIL,
            });
        });
};

export const getWhatsappEventInvitations = (data) => (dispatch, useState) => {
    dispatch({ type: FETCH_RECORDS });
    const token = useState()?.auth?.token
    var end;

    switch (token.split(" ")[0]) {
        case "Admin": end = endpoints.admin.viewEventInvitations; break;
        case "Super": end = endpoints.super.viewEventInvitations; break;
        case "Partner": end = endpoints.partner.viewEventInvitations; break;
        default: break;
    }

    getRequest(data, undefined, token, end)
        .then((response) => {
            const { data } = response
            return dispatch({
                type: FETCH_RECORDS_SUCCESS,
                payload: data
            });
        })
        .catch((err) => {
            notification.error({ message: err?.response?.data?.message, style: { marginTop: "10vh" } })
            console.log(err);
            return dispatch({
                type: FETCH_RECORDS_FAIL,
            });
        });
};

export const downloadEventInvitations = (data) => (dispatch, useState) => {
    dispatch({ type: WAIT });
    const token = useState()?.auth?.token
    var end;

    switch (token.split(" ")[0]) {
        case "Admin": end = endpoints.admin.exportEventInvitations; break;
        case "Super": end = endpoints.super.exportEventInvitations; break;
        case "Partner": end = endpoints.partner.exportEventInvitations; break;
        default: break;
    }

    notification.info({ message: "Downloading Event Invitations...", style: { marginTop: "10vh" } })
    getRequest({ ...data, responseType: "arraybuffer" }, undefined, token, end)
        .then((response) => {
            download(response.data, response.headers["filename"], "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet")
            return dispatch({
                type: WAIT_SUCCESS
            });
        })
        .catch((err) => {
            notification.error({ message: err?.response?.data?.message })
            console.log(err);
            return dispatch({
                type: WAIT_FAIL,
            });
        });
};

export const exportEventStatistics = (data) => (dispatch, useState) => {
    dispatch({ type: WAIT });
    const token = useState()?.auth?.token;
    var end;

    switch (token.split(" ")[0]) {
        case "Admin": end = endpoints.admin.exportEventStatistics; break;
        case "Super": end = endpoints.super.exportEventStatistics; break;
        default: break;
    }

    notification.info({ message: "Exporting event statistics...", style: { marginTop: "10vh" } });
    getRequest({ ...data, responseType: "arraybuffer" }, undefined, token, end)
        .then((response) => {
            const contentDisposition = response.headers["content-disposition"];
            const filename = contentDisposition
                ? contentDisposition.split("filename=")[1]?.replace(/"/g, "").trim()
                : "event_statistics.xlsx";
            download(response.data, filename, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet");
            notification.success({ message: "Export completed", style: { marginTop: "10vh" } });
            return dispatch({ type: WAIT_SUCCESS });
        })
        .catch((err) => {
            notification.error({ message: err?.response?.data?.message });
            console.log(err);
            return dispatch({ type: WAIT_FAIL });
        });
};